const SelectedSubitemHeader = ({
  selectedSubitemParent,
  setSelectedSubitemParent,
}) => {
  return (
    <div
      className="d-flex align-items-center cursor-pointer"
      style={{ width: 327 }}
    >
      <i
        className="mdi mdi-chevron-left text-dark pr-1"
        style={{ fontSize: 20 }}
        onClick={() => setSelectedSubitemParent(null)}
      />
      <div className="text-dark align-self-center h5 mb-0 text-truncate">
        {selectedSubitemParent?._RecordName || "(No Name)"}
      </div>
    </div>
  );
};

export default SelectedSubitemHeader;
